import React from 'react';
import HTMLReactParser from 'html-react-parser';

import { FaRegWindowClose } from 'react-icons/fa';

import { Wrapper } from './popup.styles';

const Popup = (props) => {
  // PROPS
  const { data, setData } = props;
  // PROPS

  if (!data.length) {
    return;
  }

  return (
    <Wrapper>
      <div className="inner-pop">
        <button
          onClick={() => {
            setData('');
          }}
        >
          <FaRegWindowClose />
        </button>
        {HTMLReactParser(data)}
      </div>
    </Wrapper>
  );
};

export default Popup;
